import styles from 'components/features/rewards/rewardsPane/containers/CryptoRewardsSellPane/CryptoRewardsSellCryptoWalletStep/SelCryptoRow.styl'
import { FC, useMemo } from 'react'
import { CurrencyTicker } from 'components/features/rewards/rewardsPane/types/apiResponses'
import { CryptoCurrencyLogo } from 'components/features/rewards/rewardsPane/containers/CryptoCurrencyLogo/CryptoCurrencyLogo'
import Button from 'components/features/pfm/Button/Button'
import { formatUSCurrency } from 'helpers/formatHelpers'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { getBalanceUsd } from 'components/features/rewards/rewardPage/helpers'

type SelCryptoRowProps = {
  ticker: CurrencyTicker
  onSelect: () => void
}
export const SelCryptoRow: FC<SelCryptoRowProps> = (props) => {
  const { ticker, onSelect } = props

  const name = useStoreSelector((state) => state.data.cryptoRewardsPane.currenciesMeta.currenciesMeta?.byKey[ticker].name)
  const walletItem = useStoreSelector((state) => state.data.cryptoRewardsPane.cryptoRewards.cryptoWallet.byKey[ticker])
  const balance = useMemo(() => {
    return getBalanceUsd(walletItem.balance_crypto, walletItem.price)
  }, [walletItem.balance_crypto, walletItem.price])


  return (
    <div className={ styles.row }>
      <div className={ styles.icon }>
        <CryptoCurrencyLogo currencyId={ ticker } />
      </div>
      <div className={ styles.description }>
        <h5>{ name }</h5>
        <span>{ balance && formatUSCurrency(balance, 'penny') }</span>
      </div>
      <div className={ styles.action }>
        <Button size='mini' onClick={ onSelect }>Select</Button>
      </div>
    </div>
  )
}
